export default {
	cardInfo: "Ficha / Médium · Guía",
	addTicket: "Agregar",
	selectConsultantFirst: "Seleccione un consultante primero",
	cardFull: "Esta ficha está llena",
	onlyDuringInProgress: "Disponible solo cuando el ritual esté en progreso",
	noTicketsYet: "Ninguna ficha distribuida aún",
	noAttendanceCards: "No hay fichas de atención configuradas para este tipo de ritual",
	errorLoadingCards: "Error al cargar fichas de atención",
	errorLoadingRitual: "Error al cargar información del ritual",
	ritualNotAvailable: "Este ritual no está disponible para distribución de fichas",
	showNames: "Mostrar nombres",
	hideNames: "Ocultar nombres",
	hasReservation: "Reserva garantizada",
	totalTickets: "Fichas",
	pendingCount: "Pendientes",
	preSenha: {
		title: "Pre-turno",
		called: "Número {number} llamado",
		resetSuccess: "Pre-turno reiniciado",
		errorCalling: "Error al llamar pre-turno",
		errorResetting: "Error al reiniciar pre-turno",
	},
	alreadyHasTicket: "Esta persona ya tiene ficha en este ritual",
	assignTicket: "Asignar Ficha",
	attendance: "Atención",
	cancelTicket: "Cancelar Ficha",
	changeConsultant: "Cambiar",
	clickToDeselect: "Haga clic para deseleccionar",
	clickToSelect: "Haga clic para seleccionar posición",
	confirmCancel: "Confirmar Cancelación",
	confirmCancelMessage: "¿Está seguro de que desea cancelar esta ficha? El consultante quedará bloqueado en este ritual.",
	confirmDelete: "Confirmar Eliminación",
	confirmDeleteMessage: "¿Está seguro de que desea eliminar esta ficha? El consultante podrá obtener una nueva ficha.",
	consultantAlreadyHasTicket: "Este consultante ya tiene ficha activa en este ritual",
	consultantHasCancelledTicket: "Este consultante tiene ficha cancelada en este ritual",
	consultantInfo: "Información del Consultante",
	consultationFinishedSuccess: "¡Consulta finalizada con éxito!",
	consultationTime: "Horario de la Consulta",
	createNewConsultant: "Registrar Nueva Persona",
	deleteTicket: "Eliminar Ficha",
	errorCreatingTicket: "Error al crear ficha de atención",
	errorLoadingConsultant: "Error al cargar consultante",
	errorLoadingConsultants: "Error al cargar consultantes",
	errorLoadingHistory: "Error al cargar historial del consultante",
	finishConsultation: "Finalizar Consulta",
	inProgress: "En Curso",
	loadingHistory: "Cargando historial...",
	mediumName: "Médium",
	noActiveRitual: "Ningún ritual en curso en este momento",
	noAttendanceCardsHint: "Verifique si el tipo de ritual tiene tipos de atención vinculados en las configuraciones.",
	noConsultantsFound: "Ningún consultante encontrado",
	noHistoryFound: "Ningún historial encontrado para este consultante",
	searchConsultant: "Buscar persona para consulta",
	selectConsultant: "Seleccionar Consultante",
	selected: "Seleccionada",
	status: {
		cancelled: "Cancelada",
		completed: "Concluida",
		in_progress: "En Atención",
		pending: "Pendiente",
	},
	ticketAssignedSuccess: "¡Ficha asignada con éxito!",
	ticketCancelledSuccess: "¡Ficha cancelada con éxito!",
	ticketDeletedSuccess: "¡Ficha eliminada con éxito!",
	ticketDetails: "Detalles de la Ficha",
	ticketSlotOccupied: "Esta posición de ficha ya está ocupada",
	typeToSearch: "Escriba para buscar consultantes",
	viewProfile: "Ver Perfil",
};
